import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { Button, useMediaQuery } from '@spothero/ui';
import SpotListItemBase from 'common/spot-card-base/v2';
import FacilitySummary from 'common/facility-summary/v2';
import { push as pushTo } from 'store/router/router-actions';
import { showSpotsLeft } from 'utils/spot-left';
import { setSpotDetailReferrer as setSpotDetailReferrerTo } from 'store/spot/spot-actions';
import DynamicSpotListItemButton from '../spot-card-dynamic-CTA-button';
import { FACILITY_SUMMARY_VIEW_TYPES } from 'common/facility-summary/utils';
import { useDispatch } from 'react-redux';
import { routeToSpotDetails } from 'router/router-utils';
import AirportCardTransportation from './AirportSpotTransportation';
import AirportSpotTag from './AirportSpotTag';
import AirportDistance from './AirportDistance';
export const SpotListItemAirport = ({ spot, isActive, isHighlighted, isAdmin, isRebookingReservation, updateSelectedSpot, onShowDetailsClick, onBookSpotClick, referer = 'list', optimizely, }) => {
    const dispatch = useDispatch();
    const { location } = useHistory();
    const { spotId, availability, facilityType, transportation, tag } = spot;
    const { available, availableSpaces } = availability;
    const containerClasses = classNames({ 'SpotListItem-active': isActive }, { 'SpotListItem-hovered': isHighlighted }, { unavailable: !available });
    const handleShowDetailsClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();
        setSpotDetailReferrerTo(referer);
        routeToSpotDetails({
            method: (...args) => dispatch(pushTo(...args)),
            location,
            spotId,
            historyState: { referrer: referer },
        });
        if (onShowDetailsClick) {
            onShowDetailsClick({ spotId });
        }
        routeToSpotDetails({
            method: (...args) => dispatch(pushTo(...args)),
            location,
            spotId,
            historyState: { referrer: referer },
        });
    };
    const handleBookSpotClick = evt => {
        evt.preventDefault();
        evt.stopPropagation();
        if (onBookSpotClick) {
            onBookSpotClick({ spotId });
        }
        updateSelectedSpot({
            spot,
            referrer: referer,
            goToSpotUrl: true,
            optimizely,
        });
    };
    const isShowSpotsLeftVisible = showSpotsLeft({
        available,
        availableSpaces,
        facilityType,
    });
    const [isDeviceSmallerThan360px] = useMediaQuery('(max-width: 360px)');
    const showImages = useMemo(() => !isDeviceSmallerThan360px, [
        isDeviceSmallerThan360px,
    ]);
    const updatedImages = [spot.logo, ...spot.images];
    return (<SpotListItemBase spotId={spotId} additionalClasses={containerClasses} onClick={handleShowDetailsClick} MainContent={<FacilitySummary 
        // @ts-ignore
        spot={{
                ...spot,
                images: updatedImages,
            }} showImages={showImages} AirportTag={<AirportSpotTag tag={tag} title={spot.title} spotsLeft={isShowSpotsLeftVisible ? availableSpaces : null}/>} isAdmin={isAdmin} isShowSpotsLeftVisible={isShowSpotsLeftVisible} view={FACILITY_SUMMARY_VIEW_TYPES.SPOT_LIST} AirportDistance={<AirportDistance spot={spot}/>} AirportTransportationInfo={<AirportCardTransportation type={transportation?.type || ''}/>} CTAs={<>
                            <Button variant="tertiary" onClick={handleShowDetailsClick} display={!available ? 'none' : 'inline-flex'}>
                                Details
                            </Button>
                            <DynamicSpotListItemButton isAdmin={isAdmin} available={available} isRebookingReservation={isRebookingReservation} isHovered={isHighlighted} onClick={handleBookSpotClick}/>
                        </>}/>}/>);
};
export default React.memo(SpotListItemAirport);
